import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Modal, Spin } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import ModalUpload from "./ModalUpload";
import downloadExcel from "../../../../services/downloadExcel";
import momentTZ from "moment-timezone";
import { errorMessage } from "../../../Utils";
let cancelToken

class GrossProfit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCar: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "carName", direction: "asc" },
    };
    this.addFileList = this.addFileList.bind(this);
  }

  componentDidMount() {
    this.fetchNewCar(this.state.page, this.state.limit);
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  orderBy(sort) {
    let key = "carName";
    let value = "ASC";

    //Get Key
    if (sort.name === "New Car") key = "carName";
    else if (sort.name === "Otr") key = "otr";
    else if (sort.name === "Gross Profit") key = "grossProfit";
    else if (sort.name === "Tanggal Update") key = "date";
    else if (sort.name === "Area") key = "area";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchNewCar(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&page=${page}&limit=${limit}&search=${
      this.state.search || ""
    }`;

    //Check if there are any previous pending requests
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.")
    }
    cancelToken = Axios.CancelToken.source();

    const data = await axios
      .get(`admin-panel/new-car-list?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then(result => {
        this.setState({
          newCar: result.data.newCar,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        } 
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchNewCar(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  openModal() {
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false, fileList: null, disableButton: true });
  }

  addFileList(file) {
    this.setState({ fileList: file, disableButton: file ? false : true });
  }

  async downloadData() {
    const data = await axios
      .get("admin-panel/new-car-list?area=ASC")
      .then(result => {
        if (result.data.newCar.length > 0) {
          const newCar = result.data.newCar.map((item, idx) => {
            return {
              no: idx + 1,
              carName: item.carName,
              otr: item.otr,
              grossProfit: item.grossProfit,
              productDetailUrl: item.productDetailUrl,
              area: item.Area ? item.Area.name : null,
            };
          });
          downloadExcel(newCar, "New Car - OTR");
        }
      })
      .catch(err => {
        message.error(err.response.message);
      });
  }

  async uploadData() {
    const { fileList } = this.state;
    if (fileList) {
      this.setState({ confirmLoading: true });
      let formData = new FormData();
      formData.append("file", fileList);
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/admin-panel/otr/update`,
        formData
      )
        .then(res => {
          message.success("Berhasil Update OTR");
          this.setState({
            confirmLoading: false,
            openModal: false,
            isLoading: true,
            fileList: null,
            disableButton: true,
          });
          this.fetchNewCar(1, this.state.limit);
        })
        .catch(e => {
          if (e.response) {
            if (e.response.data || e.response.message) {
              message.error(
                e.response.data.message || e.response.message || e.response.data
              );
            } else {
              message.error("Please upload only csv file.");
            }
          } else {
            message.error("Please upload only csv file.");
          }
          this.setState({ confirmLoading: false });
        });
    } else {
      message.error("Silahkan pilih file CSV terlebih dahulu");
    }
  }

  render() {
    //Columns
    const columns = [
      {
        name: "No",
        options: {
          sort: false,
        },
      },
      {
        name: "New Car",
        options: {
          sort: true,
        },
      },
      {
        name: "Otr",
        options: {
          sort: true,
        },
      },
      {
        name: "Gross Profit",
        options: {
          sort: true,
        },
      },
      {
        name: "Area",
        sort: true,
      },
      {
        name: "Link Url",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Update",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const newCar = this.state.newCar.map((item, idx) => {
      return [
        this.state.limit * (this.state.page - 1) + (idx + 1),
        item.carName,
        `Rp.${this.formatRupiah(item.otr ? item.otr : 0)},-`,
        `Rp.${this.formatRupiah(item.grossProfit ? item.grossProfit : 0)},-`,
        item.Area ? item.Area.name : null,
        <div>
          <a href={item.productDetailUrl} target="_blank">
            {item.productDetailUrl}
          </a>
        </div>,
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "360px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
          default:
          // console.log(action);
        }
      },
    };

    return (
      <Card
        title="List New Car"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.downloadData()}>Download Data</Button>

          <Button onClick={() => this.openModal()} style={{ marginLeft: 10 }}>
            Upload Data
          </Button>
        </div>

        <Modal
          visible={this.state.openModal}
          title="Upload Data OTR"
          onOk={() => this.uploadData()}
          onCancel={() => this.closeModal()}
          confirmLoading={this.state.confirmLoading}
          okButtonProps={{ disabled: this.state.disableButton }}>
          <ModalUpload fileList={this.addFileList} />
        </Modal>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List New Car"
              data={newCar}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default GrossProfit;



// WEBPACK FOOTER //
// src/components/Dashboard/Update/OTR/OTR.js